import React from 'react';
import styles from './CartItem.module.scss';
import Delete from '../../../icons/Delete';
import currency from 'currency.js';
import { orderPackageSubtotal } from '../../../../utils/functions';

export default function Footer({ orderPackage, removeItem, editable }) {
  return (
    <div className={styles.footer}>
      {editable ? <Delete onClick={() => removeItem(orderPackage.id, 'orderPackage')} /> : <div />}
      <p>{currency(orderPackageSubtotal(orderPackage)).format()}</p>
    </div>
  )
}
